export const homeBtnMoneyHandler = {
  homeBtnMoneyHandler_deposit: "Deposit",
  homeBtnMoneyHandler_withdraw: "Withdraw",
  homeBtnMoneyHandler_transfer: "Transfer",

  homeBtnMoneyHandler_balance: "Current Balance",
};
